import { render, staticRenderFns } from "./GeneralText22.vue?vue&type=template&id=bc00e8e4&scoped=true&"
import script from "./GeneralText22.vue?vue&type=script&lang=js&"
export * from "./GeneralText22.vue?vue&type=script&lang=js&"
import style0 from "./GeneralText22.vue?vue&type=style&index=0&id=bc00e8e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc00e8e4",
  null
  
)

export default component.exports